import script from "./_ticket-image-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./_ticket-image-modal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__